import { z } from "zod";

const formAddOtherPartnerToProjectSchema = z.object({
  partnerSelected: z
    .object({
      value: z.number(),
      label: z.string(),
    })
    .nullable()
    .refine((data) => data !== null, {
      message: "Izberite partnerja",
    }),

  vlogaID: z
    .number()
    .nullable()
    .refine((val) => val !== null, {
      message: "Izberite vlogo partnerja",
    }),

  vodjaProjekta: z.string().optional(),
  kontaktnaOseba: z.string().optional(),
});

export default formAddOtherPartnerToProjectSchema;
